import { render, staticRenderFns } from "./NewsArticlePage.vue?vue&type=template&id=73494c9d"
import script from "./NewsArticlePage.vue?vue&type=script&lang=js"
export * from "./NewsArticlePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports